angular.module('PTK.directives.Directives', [])

.directive('directiveIf', function ($compile) {

    // Error handling.
    var compileGuard = 0;
    // End of error handling.

    return {

        // Set a high priority so we run before other directives.
        priority: 100,
        // Set terminal to true to stop other directives from running.
        terminal: true,

        compile: function() {
            return {
                pre: function(scope, element, attr) {

                    // Error handling.
                    // Make sure we don't go into an infinite
                    // compile loop if something goes wrong.
                    compileGuard++;
                    if (compileGuard >= 10) {
                        console.log('directiveIf: infinite compile loop!');
                        return;
                    }


                    // Get the set of directives to apply.
                    var directives = scope.$eval(attr.directiveIf);

                    for (var key in directives) {
                        if (directives.hasOwnProperty(key)) {

                            // if the direcitve expression is truthy
                            if (directives[key]) {
                                attr.$set(key, true);
                            } else {
                                attr.$set(key, null);
                            }
                        }
                    }

                    // Remove our own directive before compiling
                    // to avoid infinite compile loops.
                    attr.$set('directiveIf', null);

                    // Recompile the element so the remaining directives
                    // can be invoked.
                    var result = $compile(element)(scope);


                    // Error handling.
                    //
                    // Reset the compileGuard after compilation
                    // (otherwise we can't use this directive multiple times).
                    //
                    // It should be safe to reset here because we will
                    // only reach this code *after* the `$compile()`
                    // call above has returned.
                    compileGuard = 0;

                }
            };

        }
    };
})

.directive('numberValidation', function(){
   return {
     require: 'ngModel',
     link: function(scope, element, attrs, modelCtrl) {

       modelCtrl.$parsers.push(function (inputValue) {

         var transformedInput = inputValue.toLowerCase().replace(/[^0-9]/g, ''); 

         if (transformedInput!=inputValue) {
           modelCtrl.$setViewValue(transformedInput);
           modelCtrl.$render();
         }         

         return transformedInput;         
       });
     }
   };
 })
 
.directive('onFinishRender', function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            if (scope.$last === true) {
                $timeout(function () {
                    scope.$emit(attr.onFinishRender);
                });
            }
        }
    }
})
 
 
.directive('animation', function() {
    return {
        restrict: 'E',
        link: function(scope, element, attrs) {
			scope.$watch('animchange', function() {
				//var url = scope.$eval(attrs.path);
				var path =  (attrs.path);
				var id = (attrs.id);
				var xmeret = 0;
				var ymeret = 0;
				var url = "";
				var res = path.split("|");
				url = res[0];
				xmeret = res[1];
				ymeret = res[2];
				element.replaceWith('<object id="'+id+'" type="text/html" width="'+xmeret+'" height="'+ymeret+'" data-dw-widget="Edge" data="'+url+'"></object>');
			});
        }
    };
})


.directive('backImg', function(){
		return function(scope, element, attrs){
			var url = attrs.backImg;
			element.css({
				'background-image': 'url(' + url +')',
				'background-size' : 'cover'
			});
		};
})

.directive('resize2', function ($window) {

    return function (scope, element, attr) {



        var w = angular.element($window);

        scope.$watch(function () {

            return {

                'h': w.height(), 

                'w': w.width()

            };

        }, function (newValue, oldValue) {


		if ( $('#coursecontainer').height() != 0 && $('#coursecontainer').width() !=0){
			scope.windowHeight = $('#coursecontainer').height();
			scope.windowWidth = $('#coursecontainer').width();
		}

		//console.log ("#coursecontainer.height:" + scope.windowHeight)
		//console.log ("#coursecontainer.width:" + scope.windowWidth)

            scope.scaleme = function () {

                scope.$eval(attr.notifier);

				if ( element.prop('offsetHeight')==0 || element.prop('offsetWidth')==0 ){
					return;
				}

				var arany = scope.ymeret_num / scope.xmeret_num;
				var ablakarany = scope.windowHeight / scope.windowWidth;
				var nagyitas = 1;
				var magassagnagyitas = 1;
				var szelessegnagyitas = 1;
				

				if ( scope.windowHeight < element.prop('offsetHeight') ){
					magassagnagyitas = Math.ceil( 100 * scope.windowHeight / element.prop('offsetHeight')) / 100;
				}

				if ( scope.windowWidth < element.prop('offsetWidth') ){
					szelessegnagyitas = Math.ceil ( 100 * scope.windowWidth / element.prop('offsetWidth')) / 100 ;
				}

				nagyitas = Math.min (magassagnagyitas, szelessegnagyitas);
				
				//Footer felhuzasa
				if ( scope.windowHeight > (element.prop('offsetHeight') * nagyitas  + 20) && element.prop('offsetHeight') != 0){
					$('#coursecontainer').height(  element.prop('offsetHeight') * nagyitas +10  );
				}

				//Footer leengedese
				if ( nagyitas < 1 &&  scope.windowWidth > (element.prop('offsetWidth') * nagyitas  + 10)  && ablakarany < arany ){
					$('#coursecontainer').height(  $('#coursecontainer').width() * arany  );
				}
				
                return { 

                    'width': scope.xmeret,
					'transform': ' scale(' + nagyitas +',' + nagyitas + ')',
					'margin': 'auto',
					'transform-origin': 'top left',
					//'transform': ' translate(-50%, -50% ) scale(' + nagyitas +',' + nagyitas + ')',
					//'transform-origin': 'center center',
					//'position': 'absolute',
					//'left': '50%',
					//'top': '50%',
                };

            };



        }, true);



        w.bind('resize', function () {

            scope.$apply();

        });

    }

})

.directive('resize', function ($window) {
    return function (scope, element, attr) {

        var w = angular.element($window);
        scope.$watch(function () {
            return {
                'h': w.height(), 
                'w': w.width()
            };
        }, function (newValue, oldValue) {
            scope.windowHeight = newValue.h;
            scope.windowWidth = newValue.w;

			
			scope.ie_ver = function(){  
				var iev=0;
				var ieold = (/MSIE (\d+\.\d+);/.test(navigator.userAgent));
				var trident = !!navigator.userAgent.match(/Trident\/7.0/);
				var rv=navigator.userAgent.indexOf("rv:11.0");

				if (ieold) iev=new Number(RegExp.$1);
				if (navigator.appVersion.indexOf("MSIE 10") != -1) iev=10;
				if (trident&&rv!=-1) iev=11;

				return iev;         
			}
			
            scope.scaleme = function () {
                scope.$eval(attr.notifier);
				
				var arany = scope.ymeret_num / scope.xmeret_num;
				var ablakarany = scope.windowHeight / scope.windowWidth;
				
				var nagyitas = 1;
				var magassagnagyitas = 1;
				var szelessegnagyitas = 1;
				var bal = "50%";
				
				if (scope.ie_ver()){
					bal = "0";
				}
				
				if ( scope.windowHeight < element.prop('offsetHeight') ){
					//magassagnagyitas = Math.floor( 10 * scope.windowHeight / element.prop('offsetHeight')) / 10;
					magassagnagyitas = Math.floor( 100 * scope.windowHeight / element.prop('offsetHeight')) / 100;
				}

				if ( scope.windowWidth < element.prop('offsetWidth') ){
					//szelessegnagyitas = Math.floor ( 10 * scope.windowWidth / element.prop('offsetWidth')) / 10 ;
					szelessegnagyitas = Math.floor ( 100 * scope.windowWidth / element.prop('offsetWidth')) / 100 ;
				}

				nagyitas = Math.min (magassagnagyitas, szelessegnagyitas);
				
				//console.log ("H" + element.prop('offsetHeight'));
				//console.log ("W" + element.prop('offsetWidth'));
				//'margin-left': (scope.windowWidth-scope.xmeret_num)/2,
				
				//console.log(scope.ie_ver());
				//ITT folytatni
				// -((1-nagyitas)*50-1)+'%'
				
				//var topszam = -(scope.xmeret * ablakarany) * (1 - nagyitas);
				
				
                return { 
                    'width': scope.xmeret,
					'transform': ' translate(-50%, 0% ) scale(' + nagyitas +',' + nagyitas + ')',
					'margin': 'auto',
					'transform-origin': 'center center',
					'position': 'absolute',
					'left': bal,
					'top': -((1-nagyitas)*40)+'%'
                };
            };

        }, true);

        w.bind('resize', function () {
            scope.$apply();
        });
    }
});

// To manage the resize
/*
PTK.directive("ceResize", function($document) {
		return function($scope, $element, $attr) {

		    // Function to manage resize right event
			var resizeRight = function($event) {
				var width = $event.pageX - $element[0].offsetLeft;
				
				if ($event.pageX > $element[0].offsetLeft + 50) {
					$element.css({
						width: width + "px"
					});
				} else {
					$element.css({
						width: "50px",
					});
				}
			};
			
			// Create a div to catch resize up event
			var newElement = angular.element('<div class="n-resize"></div>');
			$element.append(newElement);
			newElement.on("mousedown", function() {
				$document.on("mousemove", mousemove);
				$document.on("mouseup", mouseup);
				
		        function mousemove($event) {
		        	event.preventDefault();
		        	resizeUp($event);
		        }
		        
		        function mouseup() {
		        	$document.off("mousemove", mousemove);
		        	$document.off("mouseup", mouseup);
		        }
			});
			
			// Create a div to catch resize right event
			newElement = angular.element('<div class="e-resize"></div>');
			$element.append(newElement);
			newElement.on("mousedown", function() {  
				$document.on("mousemove", mousemove);
		        $document.on("mouseup", mouseup);
		        
		        function mousemove($event) {
		        	event.preventDefault();
		        	resizeRight($event);
		        }
		        
		        function mouseup() {
		        	$document.off("mousemove", mousemove);
		        	$document.off("mouseup", mouseup);
		        }
			});
			
			
		};
});	
*/
